<template>
  <div class="side-center-modal side-center-modal-invite-audience h-full">
    <div class="container-share-link-audience h-full">
      <div class="share-link_title side-center_title">
        {{ $i18nPresenter.t("Audience can join at") }}
      </div>
      <div class="share-link_group">
        <div
          id="block-content-change-acode"
          ref="block-content-change-acode"
          class="flex block-content-change-acode relative"
        >
          <div
            class="change-access-code-input-wrp"
            ref="change-access-code-input-wrp"
            @click="clickInput"
          >
            <span class="container-input-audience-link">
              <span class="change-access-code-text text-base-80">{{ `${domain}/` }}</span>
              <input
                :disabled="isReadOnly"
                autocomplete="off"
                ref="input-change-access-code"
                class="change-access-code-input"
                id="setting-change-access-code-input"
                v-model="newAccessCode"
                :maxlength="10"
                @keyup.enter="changeAccessCode"
                @blur="changeAccessCode"
                @focus="focusAccessCode"
              >

              <i class="fas fa-pencil-alt" @click="focusAccessCode" v-if="!isReadOnly" />
            </span>
          </div>
          <PlanUpgradeModal
            v-if="isBeforeCurrentPeriodStart && currentUser.id"
            :popup="'bottom'"
            :name-feature="'Invite Audience'"
            :isShowTooltip="ctaUpgradeInvite"
            @outsideEvent="clickOutsideUpgradeInvite"
          />
          <div v-if="ctaUpgradeInvite && isBeforeCurrentPeriodStart" class="upgrade-arrow upgrade-arrow_slide"></div>
          <aha-button
            class="button-copy-audience-link"
            variant="primary"
            @click="copyAccessCode"
          >
            {{ $i18nPresenter.t("Copy") }}
          </aha-button>
          <span
            class="actions-kebab-menu actions-kebab-menu-invite-audience-more
              actions-kebab-menu-invite-audience-more__mobile"
            :class="{'active': showContextMenuMobile}"
            ref="aha-actions-kebab-menu-invite-audience-more pl-4"
            @click="onOpenContextMenuBlockMobile"
          >
            <aha-icon
              width="16"
              height="16"
              viewBox="0 0 16 16"
              name="kebab-menu-share"
            />
          </span>
          <aha-spinner
            v-if="submitting"
            variant="dark"
            size="xs"
          />
        </div>
      </div>
      <div v-if="textError" class="mb-2 text-red-100">
        {{ textError }}
      </div>
      <div class="kebab-menu-more-mobile mt-4 mb-8" v-if="showContextMenuMobile">
        <div class="space-x-2 text-link" ref="copy-permanent-link" @click="copyPermanentLink">
          <i class="mr-1 fas fa-link fa-fw"></i>
          <span>{{ $i18nPresenter.t("Copy permanent link") }}</span>
        </div>
      </div>
    </div>
    <div class="container-qr-code">
      <div class="qr-code-title side-center_title">
        {{ $i18nPresenter.t("Or scan QR") }}
      </div>
      <div class="qr-code-picture">
        <QrCode :presentation="presentation" v-if="permanentLink" ref="invite-audience-qr-code" />
      </div>
      <div class="qr-code-download">
        <aha-button
          size="md"
          variant="base"
          @click="clickDownloadQRCode"
        >
          {{ $i18nPresenter.t("Download") }}
        </aha-button>
        <a
          ref="download-qr-code"
          class="text-link--primary flex items-center font-bold text-sm leading-3.5"
          :href="qrCodeDownloadURL"
          download="ahaslides-qrcode.png"
          style="visibility: hidden"
        >
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import config from '@/config'
import EventBus from '@/eventBus'
import QrCode from '@/components-v2/common/qr-code/QrCode.vue'
import Utils from '@/util'
import Socket from '@/socket'
import eventCategories from '@/constant/eventCategories'
import PlanUpgradeModal from '@/components-v2/presentation-editor/editor-header/PlanUpgrade.vue'

export default {
  name: 'SideCenterInviteAudience',
  components: { PlanUpgradeModal, QrCode },
  props: {
    presentation: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      ctaUpgradeInvite: false,
      targetClick: null,
      targetX: null,
      targetY: null,
      offsetX: null,
      offsetY: null,
      layerX: null,
      layerY: null,
      newAccessCode: '',
      textError: '',
      submitting: false,
      showContextMenuMobile: false,
      qrCodeDownloadURL: null,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      userId: (state) => state.currentUser && state.currentUser.id,
    }),
    ...mapState([
      'isDisableEditPresentation',
    ]),
    isDisableEditPresentationComputed() {
      return !this.$store.state.canEditPresentation
    },
    isBeforeCurrentPeriodStart() {
      return this.$store.state.currentUser.isBeforeCurrentPeriodStart
    },
    isReadOnly() {
      return this.isDisableEditPresentationComputed
    },
    audienceDomain() {
      if (!this.presentation.whiteLabelLink) {
        return `${config.audienceDomain}`
      }
      return `https://${this.presentation.whiteLabelLink}`
    },
    domain() {
      if (!this.presentation.whiteLabelLink) {
        return `https://${config.domain}`
      }
      return `https://${this.presentation.whiteLabelLink}`
    },
    permanentLink() {
      return `${this.audienceDomain}/${this.presentation.uniqueAccessCode}`
    },
    fullAccessCode() {
      return `${this.domain}/${this.presentation.accessCode}`
    },
    isWhiteLabel() {
      return this.$store.state.plan.group === 'white-label'
    },
    isProPlan() {
      return this.$store.state.plan.group == 'pro'
    },
  },
  watch: {
    ctaUpgradeInvite(val) {
      if (val) {
        this.selectionAccessCode()
        this.$refs['input-change-access-code'].disabled = true
      } else {
        this.$refs['input-change-access-code'].disabled = false
      }
    },
  },
  mounted() {
    EventBus.$on('aha-context-menu-invite-audience: show', () => {
      this.$refs['aha-context-menu-invite-audience'].show()
    })
    EventBus.$on('aha-context-menu-invite-audience: hide', () => {
      this.$refs['aha-context-menu-invite-audience'].hide()
    })
    this.qrCodeDownloadURL = this.$refs['invite-audience-qr-code'].qrCodeImgSource
    this.newAccessCode = this.presentation.accessCode
  },
  destroyed() {
    EventBus.$off('aha-context-menu-invite-audience: show')
    EventBus.$off('aha-context-menu-invite-audience: hide')
  },
  methods: {
    iconKebabMenuClick() {
      this.$refs['aha-actions-kebab-menu-invite-audience-more'].click()
    },
    trackingOpenContextMenu() {
      Utils.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        'Share menu > Invite audience > More feature', null, null, {
          presentationId: this.presentation.id,
          userId: this.currentUser.id,
          isPresentationOwner: this.presentation.userId === this.currentUser.id,
        },
      )
    },
    onOpenContextMenuBlockMobile() {
      this.showContextMenuMobile = !this.showContextMenuMobile
      if (this.showContextMenuMobile) {
        this.trackingOpenContextMenu()
      }
    },
    onOpenContextMenuBlocks(event) {
      if (event) {
        this.targetX = event.x
        this.targetY = event.y
        this.offsetX = event.offsetX
        this.offsetY = event.offsetY
        this.layerX = event.layerX
        this.layerY = event.layerY
        this.targetClick = event.target
        EventBus.$emit('aha-context-menu-invite-audience: show')
        this.trackingOpenContextMenu()
      }
    },
    clickDownloadQRCode() {
      this.$refs['download-qr-code'].click()
      Utils.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        'Share menu > Invite audience > Download',
        null,
        null,
        {
          presentationId: this.presentation.id,
          userId: this.currentUser.id,
          isPresentationOwner: this.presentation.userId === this.currentUser.id,
        },
      )
    },
    copyAccessCode() {
      navigator.clipboard.writeText(this.fullAccessCode)
      Utils.showToastSuccess('Copied')
      Utils.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        'Share menu > Invite audience > Copy access code link',
        null,
        null,
        {
          presentationId: this.presentation.id,
          userId: this.currentUser.id,
          isPresentationOwner: this.presentation.userId === this.currentUser.id,
        },
      )
    },
    copyPermanentLink() {
      navigator.clipboard.writeText(this.permanentLink)
      Utils.showToastSuccess('Copied')
      Utils.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        'Share menu > Invite audience > Copy permanent link',
        null,
        null,
        {
          presentationId: this.presentation.id,
          userId: this.currentUser.id,
          isPresentationOwner: this.presentation.userId === this.currentUser.id,
        },
      )
    },
    upgradeInvite() {
      this.ctaUpgradeInvite = true
      Utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Share > Upgrade invite')
    },
    clickOutsideUpgradeInvite() {
      this.ctaUpgradeInvite = false
    },
    clickInput() {
      if (!(this.isWhiteLabel || this.isProPlan) && this.isBeforeCurrentPeriodStart) {
        this.ctaUpgradeInvite = true
      }
    },
    focusAccessCode() {
      if (!(this.isWhiteLabel || this.isProPlan) && this.isBeforeCurrentPeriodStart) {
        this.ctaUpgradeInvite = true
        return
      }
      if (this.isReadOnly) {
        return
      }
      this.selectionAccessCode()
    },
    selectionAccessCode() {
      const el = document.getElementById('setting-change-access-code-input')
      el.focus()
      el.select()
      el.setSelectionRange(0, 99999)
    },
    async changeAccessCode() {
      if (!(this.isWhiteLabel || this.isProPlan) && this.isBeforeCurrentPeriodStart) {
        this.ctaUpgradeInvite = true
        return
      }
      if (this.isReadOnly) {
        return
      }

      // Copy from InviteParticipants.vue
      this.textError = ''
      const newAccessCode = this.newAccessCode.trim().toUpperCase()

      if (!newAccessCode) {
        this.textError = this.$i18nPresenter.t('Please enter your access code.')
        return
      }

      if (newAccessCode === this.$store.state.presentation.accessCode ||
          (this.presentation && newAccessCode === this.presentation.accessCode)) {
        // this.textError = 'This is your current access code.'

        this.$refs['input-change-access-code'].blur()
        return
      }

      if (this.submitting) return
      this.submitting = true
      let gaTrackingCategories = eventCategories.PRESENTATION_EDITOR
      if (this.$route.name === 'Presentations') {
        gaTrackingCategories = eventCategories.PRESENTATION_LIST
      }

      try {
        const id = (this.presentation && this.presentation.id)
            || this.$store.state.presentation.id
        await this.$http.put(config.api.changeAccessCode + id, {
          accessCode: newAccessCode,
          socketId: Socket.getSocketId(),
        })
      } catch (error) {
        if (error.body.message) {
          this.textError = error.body.message
        } else {
          const msg = this.$i18nPresenter.t('Changing access code failed. Please try again.')
          Utils.showToastError(msg)
        }

        Utils.mixpanelTracking(gaTrackingCategories, 'Invite menu >  Invite participants > Change access code > Failed', newAccessCode)
        throw error
      } finally {
        this.submitting = false
      }

      this.openChangeAccessCode = false
      if (this.presentation && this.presentation.id) { // handle case empty object
        // handle cases:
        // 1. change access code here will also change access code in presentations list
        // 2. blurring access code input when empty
        // eslint-disable-next-line vue/no-mutating-props
        this.presentation.accessCode = newAccessCode
      } else {
        this.$store.state.presentation.accessCode = newAccessCode
      }

      this.$refs['input-change-access-code'].blur()
      Utils.mixpanelTracking(gaTrackingCategories, 'Invite menu > Invite participants > Change access code > Success', newAccessCode)
      const msg = this.$i18nPresenter.t('Saved')
      Utils.showToastSuccess(msg)
    },
  },
}
</script>

<style scoped lang="scss">
.side-center-modal-invite-audience {
  .side-center_title {
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    letter-spacing: 0;
    text-align: left;
    color: rgba(0, 0, 0, 1);
    margin-bottom: 12px;
  }

  .share-link_group {
    .block-content-change-acode {
      align-items: center;
      .change-access-code-input-wrp {
        align-items: center;
        background: rgba(239, 241, 247, 1);
        max-width: 325px;
        width: fit-content;
        margin-right: 15px;

        .change-access-code-input {
          background: rgba(239, 241, 247, 1);

          position: relative;
          // left: -8px;
          cursor: pointer;
        }
      }

      .button-copy-audience-link {
        margin-right: 10px;
      }

      .actions-kebab-menu-invite-audience-more {
        width: 35px;
        height: 35px;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover {
          background: rgba(239, 241, 247, 1);
          border-radius: 50px;
          cursor: pointer;
        }
      }

      .invite-audience-menu-item {
        i, svg {
          color: rgba(153, 153, 153, 1);
        }
      }
    }
  }

  .container-share-link-audience {
    margin-bottom: 20px;

    .text-red-100 {
      margin-top: 10px;
    }
  }

  .container-qr-code {
    .qr-code-picture {
      width: 106px;
      height: 106px;
      margin-bottom: 10px;

      .qr-code-wrp {
        padding: 8px;
        border: 1px solid #D3D7E1;
        border-radius: 4px;
      }
    }

    .qr-code-download {
      width: 106px;
      text-align: center;
      button{
        width: 106px;
      }
    }
  }
}

.change-access-code-input-wrp {
  &.access-code-input--active {
    @apply bg-primary-20 border-primary-90;
  }

  padding: 0.4rem;
  @apply appearance-none flex justify-between;
  @apply text-sm rounded w-full border border-secondary-20;
  @apply focus:bg-primary-20 focus:border-primary-90 focus:outline-none;
  @apply hover:bg-primary-20 hover:border-primary-90;
  .change-access-code-input {
    @apply border-none font-bold outline-none uppercase bg-none cursor-pointer pl-0.5;
    @apply focus:bg-primary-20 focus:outline-none;
    @apply hover:bg-primary-20;
    @apply max-w-24 text-base-90 truncate;
    &:focus {
      background-color: none;
    }
  }

  &:focus {
    @apply border border-base-70;
  }

  &:hover .change-access-code-input {
    @apply bg-primary-20;
  }

  .copy-btn {
    @apply font-bold text-primary-90 flex items-center;
  }
}

.block-edit-access-code{
  &.disabled{
    cursor: not-allowed;
  }
}

.container-input-audience-link{
  .fas.fa-pencil-alt {
    margin-left: 5px;
    &:hover {
      cursor: pointer;
      --tw-border-opacity: 1;
      color: rgba(52, 142, 246, var(--tw-border-opacity));
    }
  }
}

@media (max-width: 767px) {
  .side-center-modal-invite-audience {
    .share-link_group {
      .container-input-audience-link{
        display: flex;
      }
      .block-content-change-acode {
        .actions-kebab-menu-invite-audience-more {
          display: none;
        }

        .change-access-code-input-wrp {
          position: relative;
          margin-right: 5px;
          flex-grow: 2;

          .fas.fa-pencil-alt {
            position: absolute;
            top: 10px;
            right: 5px;
            display: flex;
            align-items: center;
          }
        }

        .button-copy-audience-link{
          margin-right: 5px;
        }

        .actions-kebab-menu-invite-audience-more__mobile{
          &:hover {
            background: unset;
          }
          &.active{
            background: rgba(239, 241, 247, 1);
          }
          display: flex;
          border-radius: 50%;
          width: 35px;
          height: 35px;
        }
      }
    }
  }

  .container-share-link-audience{
    .kebab-menu-more-mobile{
      .text-link{
        &:hover{
          color: unset;
        }
      }
      display: block;
      margin-top: 15px;
      line-height: 35px;
    }
  }
}
.upgrade-arrow {
  width: 0;
  height: 0;
  border-width: 0 8px 8px 8px;
  border-color: transparent transparent rgba(40, 46, 62, 1) transparent;
  border-style: solid;
  position: absolute;
  z-index: 1;
  top: 2.6rem;

  &.upgrade-arrow_presentation {
    left: calc(50% - 47px);
  }

  &.upgrade-arrow_slide {
    left: 28%;
  }
}
</style>
